import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Loader2, Users2, Building2 } from "lucide-react";

export default function Entities({ type }) {
  const [items, setItems] = useState(null);
  useEffect(() => { setItems(null); api.get(`/entities?type=${type}`).then((r) => setItems(r.data)).catch(() => setItems([])); }, [type]);

  const isPerson = type === "person";
  const Icon = isPerson ? Users2 : Building2;

  if (!items) return <div className="flex justify-center h-96 items-center text-slate-500"><Loader2 className="w-6 h-6 animate-spin" /></div>;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-display font-extrabold text-3xl text-white tracking-tight">{isPerson ? "People" : "Organizations"}</h1>
        <p className="text-slate-400 mt-2">{isPerson ? "Individuals identified across the archive." : "Companies and organizations referenced in the work."}</p>
      </div>
      {items.length === 0 ? (
        <div className="rounded-xl border border-white/5 bg-[#111827] p-16 text-center text-slate-500">
          <Icon className="w-10 h-10 mx-auto mb-4 text-slate-700" /> None identified yet.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((e, i) => (
            <Link key={e.id} to={`/entity/${e.id}`} data-testid={`entity-${e.id}`} className="flex items-center gap-4 rounded-xl border border-white/5 bg-[#111827] p-5 hover:border-blue-500/30 hover:-translate-y-1 transition-transform transition-colors duration-300 fade-up" style={{ animationDelay: `${i * 40}ms` }}>
              <div className="w-12 h-12 rounded-full bg-blue-600/15 flex items-center justify-center flex-shrink-0"><Icon className="w-6 h-6 text-blue-400" strokeWidth={1.5} /></div>
              <div className="min-w-0">
                <div className="font-display font-semibold text-white truncate">{e.name}</div>
                <div className="text-xs text-slate-500">{e.file_count} associated file(s)</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
